import type { AuthUserProfile } from 'types/auth'

export const prefilledNameParts = (user?: AuthUserProfile) => ({
  firstName: (user?.firstName ?? '').trim(),
  lastName: (user?.lastName ?? '').trim()
})

export const buildYearOptions = (count = 25): number[] => {
  const now = new Date().getFullYear()
  return Array.from({ length: count }, (_, i) => now - i)
}

type HttpError = { response?: { data?: { error?: { message?: string } } } }

export const extractMessage = (err: unknown): string | undefined =>
  (err as HttpError)?.response?.data?.error?.message
